<template>
  <el-select
    @change="changeSelect"
    v-model="entityData"
    clearable
    :placeholder="$t('请选择主题')"
    @clear="clearSelect"
    filterable
    remote
    :remote-method="getTreeDataByKeyword"
  >
    <el-option :value="selectTreeValue" style="height: auto;">
      <el-tree
        :data="treeData"
        @node-click="handleNodeClick"
        :highlight-current="true"
        :props="defaultProps"
        lazy
        :load="loadNode"
      ></el-tree>
    </el-option>
  </el-select>
</template>

<script>
import StdSubjectDomainService from '@/services/bsApi/StdSubjectDomainService'

export default {
  props: {
    standardId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      treeData: [],
      searchTreeKey: '',
      entityData: '',
      selectTreeValue: '',
      entityId: '',
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      resolve: null, // 目录树的回调方法
    }
  },
  created() {},
  watch: {
    standardId: {
      immediate: true,
      handler() {
        if (this.standardId) {
          this.getStandardList()
        } else {
          this.treeData = []
        }
      },
    },
  },
  methods: {
    /**
     * @description 关键字查询主题
     */
    getTreeDataByKeyword: _.debounce(async function getTreeData(keyword) {
      if (!keyword) {
        this.getStandardList()
        return
      }
      const res = await StdSubjectDomainService.queryTreeList({
        keyword,
      })
      if (res && res.data && res.code === 0) {
        this.treeData = _.sortBy(res.data, (item) => {
          return item.seqNo
        })
      }
    }, 300),

    // 获取主题数据
    async getStandardList() {
      const res = await StdSubjectDomainService.getTreeList({ standardId: this.standardId })
      if (res && res.data && res.code === 0) {
        this.treeData = _.sortBy(res.data, (item) => {
          return item.seqNo
        })
      }
    },
    // 选中主题树，请求关联列表
    handleNodeClick(data) {
      console.log(data, 'dataaaaaa')
      this.entityData = data.name
      this.entityId = data.id
      this.$emit('selectNode', this.entityId)
    },
    // 主题树懒加载
    async loadNode(node, resolve) {
      if (node.level > 0) {
        const parameter = {}
        if (node.data.isStandard) {
          parameter.standardId = node.data.id
        } else {
          parameter.standardId = node.data.standardId
          parameter.parentId = node.data.id
        }
        const res = await StdSubjectDomainService.getTreeList(parameter)
        if (res && res.code === 0 && res.data) {
          return resolve(res.data)
        }
        return resolve([])
      }
      return resolve([])
    },
    clearSelect() {
      this.entityData = ''
      this.entityId = ''
      this.$emit('selectNode', this.entityId)
    },
    changeSelect(val) {
      console.log(val, 'val')
    },
    clickSeach() {
      this.$refs.tree.filter(this.searchTreeKey)
    },
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
  },
}
</script>

<style lang="scss" scoped>

.el-select-dropdown__item,
.el-select-dropdown__item:hover {
  background-color: #fff !important;
}
.el-select-dropdown {
  background-color: #fff !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #fff !important;
}

</style>
